import { DataTableColumn } from '@/components/ui/data-table-customized'
import { EmployeeAcceptanceItem } from '@/modules/Regulations/types'
import { TFunction } from 'i18next'

export const buildAcceptanceColumns = (
    t: TFunction
): DataTableColumn<EmployeeAcceptanceItem>[] => [
    {
        key: 'employee_code',
        title: t('settings:employee-code'),
        width: 110,
        cellClassName: 'font-mono truncate',
        render: (value) =>
            value ? (
                <span>{String(value)}</span>
            ) : (
                <span className="text-muted-foreground">-</span>
            ),
    },
    {
        key: 'employee_name',
        title: t('full-name'),
        width: 200,
        cellClassName: 'truncate font-medium',
    },
    {
        key: 'employee_email',
        title: t('email'),
        width: 220,
        cellClassName: 'truncate text-muted-foreground',
    },
    {
        key: 'department_name',
        title: t('department'),
        width: 160,
        cellClassName: 'truncate',
        render: (value) =>
            value ? (
                <span>{String(value)}</span>
            ) : (
                <span className="text-muted-foreground">-</span>
            ),
    },
    {
        key: 'position_name',
        title: t('position'),
        width: 160,
        cellClassName: 'truncate',
        render: (value) =>
            value ? (
                <span>{String(value)}</span>
            ) : (
                <span className="text-muted-foreground">-</span>
            ),
    },
    {
        key: 'employee_start_date',
        title: t('settings:official-start-date'),
        width: 150,
        cellClassName: 'truncate',
        formatter: {
            type: 'date',
            format: 'DD/MM/YYYY',
        },
        render: (value) =>
            value ? undefined : (
                <span className="text-muted-foreground">-</span>
            ),
    },
    {
        key: 'acceptance_status',
        title: t('status'),
        width: 130,
        cellClassName: 'text-center',
        formatter: {
            type: 'options',
            options: [
                {
                    value: 'accepted',
                    label: t('accepted'),
                    color: 'success',
                },
                {
                    value: 'not_accepted',
                    label: t('not-accepted'),
                    color: 'warning',
                },
            ],
            showDot: true,
            variant: 'dot',
        },
    },
    {
        key: 'regulations_accepted_version',
        title: t('version'),
        width: 100,
        cellClassName: 'truncate',
        render: (value) =>
            value ? (
                <span className="font-mono text-xs">
                    v{String(value).replace(/^v/i, '')}
                </span>
            ) : (
                <span className="text-muted-foreground">-</span>
            ),
    },
    {
        key: 'regulations_accepted_at',
        title: t('settings:accepted-at'),
        width: 150,
        cellClassName: 'truncate',
        formatter: {
            type: 'date',
            format: 'DD/MM/YYYY HH:mm',
        },
        render: (value) =>
            value ? undefined : (
                <span className="text-muted-foreground">-</span>
            ),
    },
]
